import { render, staticRenderFns } from "./Failure.vue?vue&type=template&id=a637e428&scoped=true"
import script from "./Failure.vue?vue&type=script&lang=js"
export * from "./Failure.vue?vue&type=script&lang=js"
import style0 from "./Failure.vue?vue&type=style&index=0&id=a637e428&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a637e428",
  null
  
)

/* custom blocks */
import block0 from "./Failure.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports